import * as brandColors from '../../../utils/brand-colors';

export default () => ({
  statContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 8,
  },
  statIcon: {
    color: brandColors.grey[300],
    fontSize: 14,
    marginRight: 2,
  },
  statValue: {
    color: brandColors.grey[600],
    fontSize: 12,
  },
});
